// Copyright (C) 2014 Minted Inc.
// All Rights Reserved

M.View = M.View || {};
M.View.DesignerStorefront = M.View.DesignerStorefront || {};

// Explicitly name global variables for "use strict".
(function(M, _, $, Backbone) {
  "use strict";

  var STOREFRONT_PAGE_WIDTH = 960;

  // Number of ms to wait before resizing the popover to fill the window.
  var REFRESH_RATE = 33;

  // Singleton for referencing the active popover.
  var activePopover = null;

  // Track the initial href for replaceState when exiting the page,
  // so the user will land on the same page beneath the popover on popstate.
  var initialLocationHref = window.location.href;

  // Track the initial pathname to prevent opening a popover on
  // top of a "full-screen" Store experience.
  var initialLocationPathname = window.location.pathname;

  // Track whether an onpopstate event fired
  // before the most recent <iframe> load.
  var poppedState = false;

  /**
   * @class M.View.DesignerStorefront.Popover
   *
   * A special dialog for showing the Artist's Store on top of any
   * customer-facing page where an artist link may be clicked.
   *
   * Opens an iframe in the dialog and tracks load events, adding new
   * entries to window.history with pushState when the loads occur.
   *
   * Also tracks onpopstate events to move back and forward to previously
   * visited Store pages, reopening the iframe for those urls.
   *
   */
  M.View.DesignerStorefront.Popover = Backbone.View.extend({

    template: M.Template.DesignerStorefront.Popover,

    initialize: function() {
      this.$el = $(this.el);
      _.bindAll(this, '_resizeDialog', '_iframeLoad',
                      'openDialog', 'closeDialog');
      $(window).bind('resize', this._resizeDialog);
    },

    render: function() {
      this.renderDialog();
      this._resizeDialog();
      return this;
    },

    renderDialog: function() {
      var that = this;

      this.$el.html(this.template({ src: this.iframeSrc() }));

      this.$el.dialog({
        autoOpen: true,
        modal: true,
        width: 960,
        minHeight: 0,
        resizable: false,
        draggable: false,
        dialogClass: 'ui-dialog-full-width ui-dialog-designer-storefront',
        position: { my: "center top", at: "center top", of: window },
        open: this.openDialog,
        close: this.closeDialog
      });
      this.$elParent = this.$el.parents('.ui-dialog-designer-storefront');
      this.$elOverlay = this.$elParent.next('.ui-widget-overlay');
      if (!this.$elOverlay.length) {
        this.$elOverlay = this.$elParent.prev('.ui-widget-overlay');
      }

      // Override default styling of overlay element
      this.$elOverlay.css({
        'background-color': '#999',
        'z-index': this._getDialogZIndex() - 1
      });

      // M.closeDialogOnMaskClick() will close all overlays, but this
      // overlay can be opened from quicklook, etc., so we need to be
      // more specific about its close behavior
      // or fix M.closeDialogOnMaskClick().
      this.$elOverlay.click(function() {
        that.$el.dialog('close');
      });

      this.$iframe = this.$el.find('iframe');
      this.$iframe.load(this._iframeLoad);
    },

    renderCloseButton: function() {
      var that = this;

      // Build and attach a custom close button next to the dialog
      this.$elClose = $('<div class="closeButtonWrap">').css({
        'padding': '13px',
        'position': 'absolute',
        'z-index': this._getDialogZIndex() + 1,
        'top': '0',
        'right': '0',
        'cursor': 'pointer'
      });
      this.$elClose.append($('<div class="closeIcon"></div>'));

      // Set up click handler for close button
      this.$elClose.click(function() {
        that.$el.dialog('close');
      });
    },

    /**
     * Modifies <body> style by hiding overflow to prevent
     * scrolling outside of the dialog.
     */
    openDialog: function() {
      $('body').css('overflow', 'hidden');
    },

    /**
     * Unload the dialog. This includes:
     *   - removing the dialog
     *   - undoing style changes to body
     *   - going back in history
     *   - resetting the title
     *   - setting the activePopover singleton to null
     */
    closeDialog: function() {
      this.$el.remove();
      this.$elClose.remove();
      $('body').css('overflow', '');
      activePopover = null;
      if (this.historyIndex && !poppedState) {
        // Go back historyIndex steps when closing the dialog manually.
        // This does not apply to popstate because that implies the user
        // went back to a state where no popover data exists, and
        // the history was already updated by the browser.
        window.history.go(-(this.historyIndex));
      }
      $('title').text(this.options.title); // Reset the title.
    },

    /**
     * Adds a timestamp parameter to the url to prevent iframe caching,
     * which causes the overlay to break in some browsers (Firefox).
     *
     * @return {String} Url to use for <iframe> src attribute
     */
    iframeSrc: function() {
      var uri = new URI(this.options.url);
      return uri.setSearch('t', Date.now()).resource();
    },

    /**
     * @return {String} User-visible url for push state and the browser bar.
     */
    pushStateSrc: function() {
      var uri = new URI(this.options.url),
          segments = uri.segment();
      if (segments[0] === 'store' && segments[1] === 'o') {
        uri.segment(1, '');
      }
      return uri.resource();
    },

    /**
     * All of these will occur on an iframe loading:
     *
     * - fade in the <iframe>
     * - remove the .loading message
     * - set overflow-x inside the iframe
     * - update the history index
     * - call pushOrReplaceState
     * - resize the dialog
     */
    _iframeLoad: function() {
      this.$iframe.fadeIn(500);
      this.$el.find('.loading').remove();
      this.renderCloseButton();
      if (this.$iframe[0].contentWindow.$) {
        this.$iframe[0].contentWindow.$('body').css('overflow-x', 'hidden');
        this.$iframe[0].contentWindow.$('body').append(this.$elClose);
      }
      this.constructor.pushOrReplaceState(this.historyIndex);
      this.updateHistoryIndex(poppedState);
      this._resizeDialog();
    },

    /**
     * Sets the left positioning and height of the dialog.
     */
    _resizeDialog: _.debounce(function() {
      if (!this.$el || !this.$el.length) {
        return;
      }
      var left = Math.floor(($('body').outerWidth() - STOREFRONT_PAGE_WIDTH)/2);
      if (left < 0) {
        left = 0;
      }
      this.$elParent.css('left', left);
      this.$el.height($(window).height());
    }, REFRESH_RATE),

    /**
     * Sets the historyIndex, which tracks the distance between the current
     * position in history and the position preceding the popover's first
     * render.
     */
    updateHistoryIndex: function(poppedState) {
      if (poppedState && window.history.state &&
          window.history.state.historyIndex) {
        this.historyIndex = window.history.state.historyIndex;
      } else if (poppedState || !this.historyIndex) {
        this.historyIndex = 1;
      } else {
        this.historyIndex++;
      }
    },

    /**
     * @return {Number} The z-index value on the dialog's parent.
     */
    _getDialogZIndex: function() {
      return parseInt(this.$elParent.css('z-index'), 10);
    },

    /**
     * @return {String} <iframe>'s title
     */
    getIframeTitle: function() {
      return this.$iframe[0].contentWindow.$('title').text();
    },

    /**
     * @return {Object} Defines the popover's current state. Intended to be
     *                  interpretted in onpopstate events.
     */
    getHistoryStateObject: function() {
      // TODO: Investigate if we can save the whole <iframe> here.
      // Browsers limit the data that can be stored in history.state.
      return {
        src: this.options.url,
        historyIndex: this.historyIndex,
        title: this.getIframeTitle(),
        isOverlayPopStateEvent: true
      };
    }

  },

  {

    /**
     * @return {Boolean} True means an overlay dialog should not pop up.
     */
    isNotOverlay: function() {
      return !!(M.IS_MOBILE || M.IS_TABLET || M.IS_MOBILE_USER_AGENT);
    },

    /**
     * Creates or updates the activePopover with the url passed,
     * and calls render on activePopover if conditions for opening
     * an overlay are correct. Otherwise, sets location.
     *
     * @param  {String} url URL to use in the iframe's src attribute
     */
    setLocationAndRender: function(url) {
      var notOverlay = M.View.DesignerStorefront.Popover.isNotOverlay(),
          storeUrl = M.View.DesignerStorefront.Popover.getStoreUrlMatch(
            url, notOverlay),
          that = this;

        if (!storeUrl.then || typeof storeUrl.then !== 'function') {
          url = storeUrl;
          this.renderPopover(url, notOverlay)
        } else {
          storeUrl.then(function(data) {
            data = JSON.parse(data);

            if (data.vanity_url) {
              if (notOverlay) {
                url = '/store/'+  encodeURIComponent(data.vanity_url);
              } else {
                url = '/store/o/'+  encodeURIComponent(data.vanity_url);
              }
            }

            that.renderPopover(url, notOverlay);
        });
      }
    },

    renderPopover: function(url, notOverlay) {
      M.assert(url)

      if (notOverlay || !M.View.DesignerStorefront.Popover._isStoreUrl(
          url)) {
        window.location = url;
      } else {
        activePopover = this.createOrUpdate(url);
        activePopover.render();
      }
    },

    /**
     * Creates a dialog if activePopover singleton does not exist. Otherwise,
     * only updates activePopover's url.
     * @param  {String} url The url to set on activePopover.
     * @return {Object}     New Popover View.
     */
    createOrUpdate: function(url) {
      if (M.View.DesignerStorefront.Popover._isStoreUrl(
          initialLocationPathname)) {
        // Never open the popover on top of a storefront.
        return false;
      }

      if (!activePopover) {
        activePopover = new M.View.DesignerStorefront.Popover({
          url: url,
          title: $('title').text()
        });
      } else {
        activePopover.options.url = url;
      }
      return activePopover;
    },

    /**
     * Determines whether or not url is for a designer's store.
     * Note: Also makes sure to exclude any /store urls ending with /commission
     * because /store/<vanityUrl>/commission is used for a customer to request
     * a commission for the given artist, and it is not a store.
     *
     * @param {String} url The url to test
     * @return {Boolean}   Whether or not url matches store url
     */
    _isStoreUrl: function(url) {
      return (url.match(/\/store\//) !== null ||
        url.match(/\/storefront\//) !== null) &&
        (url.match(/^\/store\/.*\/commission/) === null &&
        url.match(/^\/artist\/.*\/commissions/) === null);
    },

    /**
     * Updates window.history by sending state data to pushState,
     * allowing the user to navigate back and forward through the
     * artist overlay predictably.
     *
     * When the <iframe> load that triggers this function was initialized
     * by an onpopstate event, use replaceState instead, to prevent adding
     * to window.history.
     */
    pushOrReplaceState: function(historyIndex) {
      var state;
      if (!poppedState && !historyIndex) {
        state = activePopover.getHistoryStateObject();
        window.history.pushState(state,
          state.title,
          activePopover.pushStateSrc(state.src));
      } else {
        state = window.history.state;
        window.history.replaceState(state,
          state.title,
          activePopover.pushStateSrc(state.src));
      }
      // Unset poppedState so the next pushState event can call pushState.
      poppedState = false;
      // Set the title
      $('title').text(state.title);
    },

    /**
     * Calls window.history.replaceState to silently change
     * the current history's location. Then set's window.location
     * to redirect outside of the popover (i.e. "frame bust").
     */
    frameBust: function(location) {
      var state = window.history.state;
      window.history.replaceState(state,
        state.title,
        initialLocationHref);
      _.defer(function() {
        window.location = location;
      });
    },

    /**
     * Handles window.onpopstate events.
     *
     * When the event's state data is not for an overlay, close the dialog.
     *
     * When the event's state data is for an overlay, setLocation to either
     * open a new dialog or apply the url to the current dialog.
     */
    handlePopState: function(e) {
      poppedState = true;
      if (!M.View.DesignerStorefront.Popover.isOverlayPopStateEvent(e)) {
        if (activePopover) {
          // When no state is provided, close the dialog.
          activePopover.$el.dialog('close');
        } else {
          // Handle weird state of history transitions:
          // minted > overlay > overlay > external url
          // external url < full page < full page < minted
          // window.location.reload();
        }
        poppedState = false;
      } else {
        M.View.DesignerStorefront.Popover.setLocationAndRender(e.state.src);
      }
      return false;
    },

    /**
     * Retrieve the VanityUrl from server given the designerID
     *
     * @param designerID
     * @returns ajax call to '/store/designer-transform-id/<designerID>'
     */
    _getVanityUrl: function(designerID) {
      return $.ajax({
        url: '/store/designer-transform-id/' + encodeURIComponent(designerID),
        async: false
      });
    },

    /**
     * Checks if the url is a store or should be hijacked to a store.
     *
     * Matches /search?...designerID=...&designerVanityUrl=... and /store/...
     *
     * @param  {String}  url           Url to parse.
     * @param  {Boolean} isNotOverlay  Whether or not the url will be for an
     *                                 overlay.
     * @return {String}                Storefront overlay url.
     */
    getStoreUrlMatch: function(url, isNotOverlay) {
      var uri = new URI(url),
          segments = uri.segment(),
          queries;
      if (segments[0] === 'search') {
        queries = uri.search(true);
        var storeUrl;
        if (isNotOverlay) {
          storeUrl = '/store/';
        } else {
          storeUrl = '/store/o/';
        }

        // Give preference to designerVanityUrl if exists; otherwise,
        // use designerID
        // TODO: remove designerID usage after delta import completed
        if (queries.designerVanityUrl) {
          return storeUrl + queries.designerVanityUrl;
        }
        if (queries.designerID) {
          var designerID = (queries.designerID).toString();
          return M.View.DesignerStorefront.Popover._getVanityUrl(designerID);
        }
      } else if (segments[0] === 'store') {
        // url is of the format '/store/o/...'
        if (segments[1] !== 'o') {
          if (M.String.isOnlyDigits(segments[1])) {
            return M.View.DesignerStorefront.Popover._getVanityUrl(segments[1]);
          }
          // return the unmodified url if it is a commission request
          if (segments.length > 2 && segments[2] === 'commission'){
            return url;
          }
          // transform url into '/store/o/...' if isNotOverlay is false
          if (!isNotOverlay) {
            uri.segment([segments[0], 'o'].concat(_.rest(segments, 1)));
          }
        } else {
          if (M.String.isOnlyDigits(segments[2])) {
            return M.View.DesignerStorefront.Popover._getVanityUrl(segments[2]);
          }
        }
      }
      return uri.resource();
    },
    /**
     * Checks if the popstate event is for navigation through an overlay.
     *
     * It accomplishes this by checking if e has a state and the state has
     * the key "isOverlayPopStateEvent", which is set on all overlay
     * pushState calls.
     */
    isOverlayPopStateEvent: function(e) {
      return !!(e && e.state && e.state.isOverlayPopStateEvent);
    }

  });

  window.onpopstate = M.View.DesignerStorefront.Popover.handlePopState;

})(M, _, $, Backbone);
